import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import clsx from 'clsx';
import { NewJoveLogo } from '../../../Logos/NewJoveLogo';
import SwitchCountryView from '../onlyJove/switchCountry';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CompareItemLabel = function CompareItemLabel(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_jsx(Grid, {
    item: true,
    xs: 2,
    className: clsx('flex flex-col items-center justify-center bg-[#f5f5f5]', className),
    children: children
  });
};

var CompareItemLeft = function CompareItemLeft(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
  return /*#__PURE__*/_jsx(Grid, {
    item: true,
    xs: 5,
    className: clsx('flex flex-col items-center justify-center border-l border-r border-white bg-[#f5f5f5] p-3', className),
    children: children
  });
};

var CompareItemRight = function CompareItemRight(_ref3) {
  var children = _ref3.children,
      className = _ref3.className;
  return /*#__PURE__*/_jsx(Grid, {
    item: true,
    xs: 5,
    className: clsx('flex flex-col items-center justify-center border-l border-r border-white bg-[#EBEFFE] p-3', className),
    children: children
  });
};

export var CompareItem = function CompareItem(_ref4) {
  var children = _ref4.children,
      className = _ref4.className;
  return /*#__PURE__*/_jsx(Grid, {
    container: true,
    className: clsx(className),
    children: children
  });
};
CompareItem.Label = CompareItemLabel;
CompareItem.Left = CompareItemLeft;
CompareItem.Right = CompareItemRight;
export var InsurerCompareItem = function InsurerCompareItem(_ref5) {
  var leftInsurer = _ref5.leftInsurer,
      rightInsurer = _ref5.rightInsurer,
      valueChange = _ref5.valueChange,
      defaultCountry = _ref5.defaultCountry,
      disableSwitchCountry = _ref5.disableSwitchCountry,
      hideCountry = _ref5.hideCountry,
      allowSelectCountryList = _ref5.allowSelectCountryList;
  return /*#__PURE__*/_jsxs(CompareItem, {
    children: [/*#__PURE__*/_jsx(CompareItem.Label, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        className: "text-center font-bold text-[#202020]",
        children: "Insurer"
      })
    }), /*#__PURE__*/_jsx(CompareItem.Left, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: "font-bold text-[#202020]",
        children: leftInsurer
      })
    }), /*#__PURE__*/_jsx(CompareItem.Right, {
      children: /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-col items-center space-y-3",
        children: [/*#__PURE__*/_jsx(NewJoveLogo, {
          mainColor: "#202020",
          className: "h-[24px] w-[76px]"
        }), !hideCountry && /*#__PURE__*/_jsx(SwitchCountryView, {
          size: "small",
          valueChange: valueChange,
          defaultCountry: defaultCountry,
          disableSwitchCountry: disableSwitchCountry,
          allowSelectCountryList: allowSelectCountryList
        })]
      })
    })]
  });
};
export var ProductCompareItem = function ProductCompareItem(_ref6) {
  var leftProducts = _ref6.leftProducts,
      rightProducts = _ref6.rightProducts;

  var renderProducts = function renderProducts(products) {
    return /*#__PURE__*/_jsx(Box, {
      className: "flex flex-col space-y-3",
      children: (products || []).map(function (product, index) {
        return /*#__PURE__*/_jsxs(Box, {
          children: [/*#__PURE__*/_jsx(Typography, {
            className: "text-xs font-bold text-[#202020]",
            children: product.title
          }), /*#__PURE__*/_jsx(Typography, {
            className: "text-[10px] font-normal text-[#202020]",
            children: product.coverageText
          })]
        }, index);
      })
    });
  };

  return /*#__PURE__*/_jsxs(CompareItem, {
    children: [/*#__PURE__*/_jsx(CompareItem.Label, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        className: "text-center font-bold text-[#202020]",
        children: "Product"
      })
    }), /*#__PURE__*/_jsx(CompareItem.Left, {
      children: renderProducts(leftProducts)
    }), /*#__PURE__*/_jsx(CompareItem.Right, {
      children: renderProducts(rightProducts)
    })]
  });
};
export var GeographicCompareItem = function GeographicCompareItem(_ref7) {
  var leftRegion = _ref7.leftRegion,
      rightRegion = _ref7.rightRegion;
  return /*#__PURE__*/_jsxs(CompareItem, {
    children: [/*#__PURE__*/_jsx(CompareItem.Label, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        className: "text-center font-bold text-[#202020]",
        children: "Geographic limitation"
      })
    }), /*#__PURE__*/_jsx(CompareItem.Left, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: "font-bold text-[#202020]",
        children: leftRegion
      })
    }), /*#__PURE__*/_jsx(CompareItem.Right, {
      children: /*#__PURE__*/_jsx(Typography, {
        className: "text-sm font-bold text-[#202020]",
        children: rightRegion
      })
    })]
  });
};
export var MonthlyPaymentCompareItem = function MonthlyPaymentCompareItem(_ref8) {
  var leftAmount = _ref8.leftAmount,
      rightAmount = _ref8.rightAmount,
      rightDownPayment = _ref8.rightDownPayment,
      rightNote = _ref8.rightNote,
      discountAmount = _ref8.discountAmount,
      discountPercentage = _ref8.discountPercentage;
  return /*#__PURE__*/_jsxs(CompareItem, {
    children: [/*#__PURE__*/_jsx(CompareItem.Label, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        className: "text-center font-bold text-[#202020]",
        children: "Monthly premium (including IPT)"
      })
    }), /*#__PURE__*/_jsx(CompareItem.Left, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: "font-bold text-[#202020]",
        children: leftAmount
      })
    }), /*#__PURE__*/_jsx(CompareItem.Right, {
      children: /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-col items-center",
        children: [/*#__PURE__*/_jsx(Box, {
          className: "flex flex-row items-center justify-center space-x-2",
          children: /*#__PURE__*/_jsx(Typography, {
            className: "text-2xl font-black text-[#0E35D1]",
            children: rightAmount
          })
        }), rightDownPayment && /*#__PURE__*/_jsxs(Typography, {
          className: "text-[10px] font-medium text-[#202020]",
          children: ["Down Payment: ", rightDownPayment]
        }), rightNote && /*#__PURE__*/_jsx(Typography, {
          className: "text-[10px] font-medium text-[#202020]",
          children: rightNote
        })]
      })
    })]
  });
};
export var AnnualPaymentCompareItem = function AnnualPaymentCompareItem(_ref9) {
  var leftAmount = _ref9.leftAmount,
      rightAmount = _ref9.rightAmount;
  return /*#__PURE__*/_jsxs(CompareItem, {
    children: [/*#__PURE__*/_jsx(CompareItem.Label, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        className: "text-center font-bold text-[#202020]",
        children: "Annual premium (including IPT)"
      })
    }), /*#__PURE__*/_jsx(CompareItem.Left, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: "font-bold text-[#202020]",
        children: leftAmount
      })
    }), /*#__PURE__*/_jsx(CompareItem.Right, {
      children: /*#__PURE__*/_jsx(Typography, {
        className: "text-2xl font-black text-[#0E35D1]",
        children: rightAmount
      })
    })]
  });
};
export var TotalPaymentCompareItem = function TotalPaymentCompareItem(_ref10) {
  var leftAmount = _ref10.leftAmount,
      rightAmount = _ref10.rightAmount;
  return /*#__PURE__*/_jsxs(CompareItem, {
    children: [/*#__PURE__*/_jsx(CompareItem.Label, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        className: "text-center font-bold text-[#202020]",
        children: "Total annual payable"
      })
    }), /*#__PURE__*/_jsx(CompareItem.Left, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: "font-bold text-[#202020]",
        children: leftAmount
      })
    }), /*#__PURE__*/_jsx(CompareItem.Right, {
      children: /*#__PURE__*/_jsx(Typography, {
        className: "text-2xl font-black text-[#0E35D1]",
        children: rightAmount
      })
    })]
  });
};